import { Store } from '@ngxs/store';
import { take, map, distinctUntilChanged, filter, delay } from 'rxjs/operators';
import { EngineState } from '../engine/state/engine.state';
import { AddHistory } from './state/history.actions';
import { HistoryModel } from './models/history.model';
import { HistoryAction } from './models/history-action.enum';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
var HistoryService = /** @class */ (function () {
    function HistoryService(store) {
        this.store = store;
    }
    /**
     * Tap into the viewgraph events to record next state. Because viewgraph changes occur asynchronously from the engine,
     * we wait until the synchornize event is called to tap into and update history.
     */
    HistoryService.prototype.recordViewGraphHistory = function () {
        var _this = this;
        var viewGraph$ = this.store.select(EngineState.getViewGraph);
        viewGraph$
            .pipe(delay(1), filter(function (viewGraph) { return Object.values(viewGraph.nodes).length > 0; }), map(function (viewGraph) {
            var nodes = Object.values(viewGraph.nodes)
                .reduce(function (result, node) {
                result[node.id] = { id: node.id, boolState: { shown: node.boolState.shown } };
                return result;
            }, {});
            return JSON.stringify(nodes);
        }), distinctUntilChanged(), take(1))
            .subscribe(function (viewGraph) {
            var nodes = JSON.parse(viewGraph);
            _this.store.dispatch(new AddHistory(new HistoryModel(HistoryAction.SetNodeVisible, nodes)));
        });
    };
    HistoryService.ngInjectableDef = i0.defineInjectable({ factory: function HistoryService_Factory() { return new HistoryService(i0.inject(i1.Store)); }, token: HistoryService, providedIn: "root" });
    return HistoryService;
}());
export { HistoryService };
